import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A flywheel energy-storage unit: a heavy steel rotor in an open-topped vacuum
// housing, spun up to bank kinetic energy and drawn down on demand. The rotor
// (named "rotor") turns about the vertical axis; marker bolts make the spin
// read.
const HOUSING = "#878e96";
const HOUSING_DK = "#6c727a";
const ROTOR = "#aeb4ba";
const SHAFT = "#5a6066";
const BOLT = "#c4392f";

const ROTOR_Y = 0.78;

function rotor(): Part[] {
  const out: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.32, 0.32, 0.18, 16), color: ROTOR, position: [0, ROTOR_Y, 0], name: "rotor" },
    { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.28, 10), color: SHAFT, position: [0, ROTOR_Y + 0.1, 0], name: "rotor" },
  ];
  // Marker bolts near the rim so rotation is visible.
  for (let i = 0; i < 4; i++) {
    const a = i * Math.PI / 2;
    out.push({ geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.04, 6), color: BOLT, position: [Math.cos(a) * 0.24, ROTOR_Y + 0.1, Math.sin(a) * 0.24], name: "rotor" });
  }
  return out;
}

export const flywheelStorage = defineModel({
  id: "flywheel-storage",
  batchId: "electric",
  name: "Flywheel storage",
  tags: ["building", "electric", "power", "storage", "flywheel", "animated"],
  summary: "A spinning steel rotor in a vacuum housing that banks kinetic energy.",
  footprint: 0.5,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(0.9, 0.12, 0.9), color: "#5a5a5e", position: [0, 0.06, 0] },
      // Vacuum housing drum, open at the top.
      { geometry: new THREE.CylinderGeometry(0.42, 0.46, 0.62, 18), color: HOUSING, position: [0, 0.43, 0] },
      { geometry: new THREE.CylinderGeometry(0.43, 0.43, 0.06, 18), color: HOUSING_DK, position: [0, 0.71, 0] },
      { geometry: new THREE.CylinderGeometry(0.36, 0.36, 0.05, 18), color: "#3a3a3e", position: [0, 0.69, 0] },
      // Control box on the side.
      { geometry: new THREE.BoxGeometry(0.16, 0.3, 0.12), color: HOUSING_DK, position: [0.5, 0.27, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.06, 0.02), color: "#3aa0d0", position: [0.5, 0.36, 0.07] },
      ...rotor(),
    ];
  },
  animations: [
    {
      id: "spin",
      label: "Rotor spinning",
      duration: 1.6,
      loop: true,
      tracks: [
        { target: "rotor", pivot: [0, ROTOR_Y, 0], rotation: [{ t: 0, value: [0, 0, 0] }, { t: 1.6, value: [0, Math.PI * 2, 0] }] },
      ],
    },
  ],
});
